const state = {
};

const getters = {
};

const actions = {
    LoadServerFirewall({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('server_firewall.load_data', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    SaveServerFirewall({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('server_firewall.save_data', {
                entity_id: request_data['entity_id']
            });

            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    GetEntityServices({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('server_firewall.load_entity_services', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    GetIpAddress({ commit} ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('server_firewall.get_ip_address');

            this._vm.$axios.post(r)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                });
        });
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};